import { ChartEndLabels, ChartHeadline } from "./chart-parts";
import {
  chartChangeText,
  formatChartValue,
  type ChartPoint,
} from "./chart-points";

/**
 * One big number: the latest value at twice the headline size, its change on
 * the point before, and the period it closes (first and last label).
 */
export function ChartNumber({
  points,
  unit,
  testIdPrefix,
}: {
  points: readonly ChartPoint[];
  unit: string;
  testIdPrefix: string;
}) {
  const latest = points.length - 1;
  return (
    <>
      <ChartHeadline
        value={formatChartValue(points[latest]!.value)}
        unit={unit}
        change={chartChangeText(points, latest)}
        large
        testId={`${testIdPrefix}-value`}
      />
      <ChartEndLabels
        first={points[0]!.label}
        last={points[latest]!.label}
        className="mt-auto"
        testId={`${testIdPrefix}-labels`}
      />
    </>
  );
}
